export default {seo:{title:'Modification du compte',description:null},title:'Compte & Mot de passe'};